// extracted by mini-css-extract-plugin
export var hidden = "_vd-0";